export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_sl.9450c227e6838ee7.json"